import React from 'react';

import { useSidebarLayoutBase } from '../contexts/SidebarLayoutBase/SidebarLayoutBaseContext';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import loadable from '@wix/yoshi-flow-editor/loadable';

import { classes } from '../SidebarLayoutForParticipant.st.css';

export interface AiChatPanelProps {
  className?: string;
}

const AIChat = loadable(() => {
  return import(/* webpackPrefetch: true */ './AIChat/AIChat');
});

const AiChatPanel: React.FC<AiChatPanelProps> = ({ className }) => {
  const { isAiChatEnabled } = useSidebarLayoutBase();
  const { isMobile } = useEnvironment();

  if (!isAiChatEnabled) {
    return null;
  }

  if (isMobile) {
    return null;
  }

  return (
    <div className={`${classes.aiChatContainer} ${className || ''}`}>
      <div className={classes.verticalDivider} />
      <div className={classes.aiChatContent}>
        <AIChat />
      </div>
    </div>
  );
};

export default AiChatPanel;
